
/**
 * @file Custom Typefaces
 */

import "./src/style/all.scss"
import "typeface-montserrat"
import "typeface-merriweather"
import "typeface-nunito"
import "typeface-alegreya"
